import { tss } from 'tss-react/mui';

export const useForgotPageStyles = tss.create(({ theme }) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 12,
  },
  layout: {
    backgroundColor: theme.palette.background.default,
    backgroundImage: "url('/overlay.jpg'), url('/bg.jpg')",
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  },
}));
